import { commonRoutes } from '@rikstv/play-common/src/router/router.path';

import { ContentStackMetadata, SuperCoverPageData, VariantBehavior } from '../contentStack.types';

export const getStackContent = (data: SuperCoverPageData): ContentStackMetadata => {
  switch (data.type) {
    case 'episode':
      return data.episode;
    case 'series':
      return data.series;
    case 'singleProgramOrMovie':
      return data.singleProgramOrMovie;
  }
};

// behaviors that start playback in our own player, as opposed to commerce or account actions
export const isOwnPlaybackBehavior = (behavior?: VariantBehavior | 'ShowVariants') =>
  behavior === 'PlayAsset' || behavior === 'PlayChannel';

export const isTransactionBehavior = (behavior?: VariantBehavior | 'ShowVariants') =>
  behavior === 'RentAsset' || behavior === 'PurchaseAsset';

export const getSeriesLinkIfEpisode = (media: ContentStackMetadata) => {
  if (media.type !== 'episode' || media._links.superCoverPage?.id == null || media.metadata.seriesName == null) {
    return { seriesLink: null, seriesName: null };
  }
  return {
    seriesLink: commonRoutes.stackedSeriesOrMovie({
      id: media._links.superCoverPage.id,
      isSeries: true,
      title: media.metadata.seriesName,
    }),
    seriesName: media.metadata.seriesName,
  };
};
